import React from "react";

export function useAsyncCallbackWithStatus<
  T,
  U,
  Args extends Array<unknown> = [T] | [T, U],
>(passedFunction: (...args: Args) => Promise<unknown>) {
  const [isProcessing, setIsProcessing] = React.useState(false);

  const functionWithStatus = React.useCallback(
    async (...args: Args) => {
      setIsProcessing(true);
      const result = await passedFunction(...args);
      setIsProcessing(false);

      return result;
    },
    [passedFunction]
  );

  return [functionWithStatus, isProcessing] as const;
}
